import Translator from "./Translator";

export default function Index() {
  return <Translator />;
}
